document.addEventListener("alpine:init", () => {
    Alpine.data("marqueeSlider", () => ({
        offset: 0,
        speed: 0.5,
        singleSetWidth: 0,

        init() {
            this.track = this.$el.querySelector(".marquee__inner");

            const gap = getComputedStyle(this.track).gap;
            const gapX = parseFloat(gap.split(" ")[1].replace("px", "")) / 2;

            setTimeout(() => {
                this.singleSetWidth = (this.track.scrollWidth / 2) + gapX;
                requestAnimationFrame(this.animate.bind(this));
            }, 200);
        },

        animate() {
            this.offset -= this.speed;

            if (Math.abs(this.offset) >= this.singleSetWidth) {
                this.offset += this.singleSetWidth;
            }

            this.track.style.transform = `translateX(${this.offset}px)`;

            requestAnimationFrame(this.animate.bind(this));
        },
    }));
});
